// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"586":"164b8219","952":"3ddbde12"}[chunkId] + ".chunk.js";
};